// AUTO-GENERATED SQL Builder (V40 Final) for Notification
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class NotificationSql {
  private ast = new SqlAst('Notification', 'notification');
  public readonly main: any = {};

  public guid: SqlField;
  public userId: SqlField;
  public vendorId: SqlField;
  public type: SqlField;
  public title: SqlField;
  public body: SqlField;
  public relatedBookingId: SqlField;
  public isRead: SqlField;
  public createdByUser: SqlNavHybrid;
  public relatedBooking: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public user: SqlNavHybrid;
  public vendor: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('notification', 'guid', '', 'id', 'notification_guid');
    this.userId = new SqlField('notification', 'userId', 'user', 'id', 'notification_user');
    this.vendorId = new SqlField('notification', 'vendorId', 'vendor', 'id', 'notification_vendor');
    this.type = new SqlField('notification', 'type', '', 'id', 'notification_type');
    this.title = new SqlField('notification', 'title', '', 'id', 'notification_title');
    this.body = new SqlField('notification', 'body', '', 'id', 'notification_body');
    this.relatedBookingId = new SqlField('notification', 'relatedBookingId', '', 'id', 'notification_relatedBooking');
    this.isRead = new SqlField('notification', 'isRead', '', 'id', 'notification_isRead');
    this.createdByUser = createNavHybrid('notification', 'notification_createdByUser', 'User');
    this.relatedBooking = createNavHybrid('notification', 'notification_relatedBooking', 'Booking');
    this.updatedByUser = createNavHybrid('notification', 'notification_updatedByUser', 'User');
    this.user = createNavHybrid('notification', 'notification_user', 'User');
    this.vendor = createNavHybrid('notification', 'notification_vendor', 'Vendor');
    this.id = new SqlField('notification', 'id', '', 'id', 'notification_id');
    this.isDeleted = new SqlField('notification', 'isDeleted', '', 'id', 'notification_isDeleted');
    this.createdBy = new SqlField('notification', 'createdBy', '', 'id', 'notification_createdBy');
    this.createdDate = new SqlField('notification', 'createdDate', '', 'id', 'notification_createdDate');
    this.updatedBy = new SqlField('notification', 'updatedBy', '', 'id', 'notification_updatedBy');
    this.updatedDate = new SqlField('notification', 'updatedDate', '', 'id', 'notification_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:NotificationSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:NotificationSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:NotificationSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:NotificationSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:NotificationSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:NotificationSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:NotificationSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:NotificationSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:NotificationSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:NotificationSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
